import { AuthContextProps } from "../components/auth-context";
import { getData} from "./core";

export default class ElectronicBankAccountApi {
  static unauthorizedUri = "n/accounts/electronicBankAccount";
  static authorizedUri = "a/accounts/electronicBankAccount";
  context?: AuthContextProps;
  constructor(context?: AuthContextProps) {
    this.context = context;
  }
  get(amount: number, receiptId: string | undefined) {
    return getData({
      uri: `${ElectronicBankAccountApi.authorizedUri}`,
      params: `?id=${amount}&receiptId=${receiptId}`,
      context: this.context,
    });
  }
  
}